import React, { FC } from 'react'
import { Icon, IconProps } from '@chakra-ui/react'
import { defineDirection, Direction } from './definitions'

type ChevronProps = IconProps & {
  direction?: Direction
}

const Chevron: FC<ChevronProps> = ({ direction = Direction.Left, ...chakraProps }) => (
  <Icon
    transform={defineDirection(direction)}
    viewBox="0 0 17 28"
    // ChakraUIs type definitions clash apparently.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {...(chakraProps as any)}>
    <path
      d="M0.654844 3.15999L3.02824 0.799988L16.2149 14L3.01484 27.2L0.654844 24.84L11.4948 14L0.654844 3.15999Z"
      fill="currentColor"
    />
  </Icon>
)

// eslint-disable-next-line functional/immutable-data
Chevron.displayName = 'Chevron'

export { Chevron }
